import { Component } from '@angular/core';
import { Company } from 'src/app/models/company.model';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.css']
})
export class CompaniesListComponent {
  companys: Company[] = [];
  dtoptions: DataTables.Settings = {}

  constructor(private companysService: CompanysService, private router: Router,
  ) { }

  navigate(TId) {
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/component/companies/edit/' + id]);
  }

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User' || loggedInuserRole.role == 'Internal User' || loggedInuserRole.role == 'Regional User') {
      this.logout();
    }
    this.dtoptions = {
      pagingType: 'full_numbers'
    };
    this.companysService.getAllCompanys()
      .subscribe({
        next: (companys) => {
          this.companys = companys;
       
        },
        error: (response) => {
          console.log(response);
        }
      })
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
